module.exports = __webpack_public_path__ + "img/viacom.f50a8700.svg";